import { throwError } from 'rxjs';
import { Injectable, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// Json
import * as options from '../json/options.json';
import * as apiEndpoints from '../json/endpoints.json';
import { settings } from 'cluster';

const server = 'https://beta.ziraxi.com/v1';
const serverV3 = 'https://beta.ziraxi.com/v3';
export const urls = {
  auth: {
    forgetPassword: server + '/auth/password-reset/request',
    verifyForgetPasswordOtp: server + '/auth/password-reset/verify-code',
    setNewPassword: server + '/auth/password-reset/set-password',
  },
  user: {
    changeActivation: server + '/user/change-activation/:id',
    changeUserRole: server + '/user/update/role/:id',
    getReferreds: server + '/user/referred',
    getUserDiscounts: server + '/user/discounts/:id',
    checkDiscountCode: server + '/discounts/check/{code}'
  },
  admin: {
    getAllTasks: server + '/tasks',
    addNewTask: server + '/tasks',
    updateTask: server + '/tasks/update/:id',
    deleteTask: server + '/tasks/:id',
    editUserScore: server + '/score/update/user/:id',
    generateDiscount: server + '/discounts/generate',
    stock: {
      binding: server + '/stock/binding',
    },
    settings:{
      updateBindSalaryFee: serverV3 + '/settings/configure/orderConf/update'
    }
  }
};

@Injectable()
export class ConfigService {
  /**
   * Get endpoints very easy like:
   * this.configService.get('user.activate');
   *
   * @param path endpoint object path.
   * @param {boolean} returnRelative return relative not full url.
   */
  public getUrl<T>(path: string, apiVersion = 1): string {
    try {
      const splitted = this.separateByDots(path, apiVersion);
      const relative = this.getTarget<string>(splitted, apiEndpoints);
      return this.mixWithBaseUrl(relative, apiVersion);
    } catch (e) {
      console.error("There's a problem with configService");
      console.error(`With Target string: (${path})`);
      console.error(`in Getting url`);
      throw e;
    }
  }

  public getFrontendBaseUrl(): string {
    return window.location.protocol + '//' + window.location.host;
  }

  /**
   * Get options
   * There is options defined as json.
   * You can load theme by this method.
   * @param path path of option in object.
   * @deprecated The method would not work
   */
  public getOption(path: string): string {
    try {
      const splitted = this.separateByDots(path);
      const data = this.getTarget<string>(splitted, options);

      return data;
    } catch (e) {
      throw e;
    }
  }

  public mixWithBaseUrl(url: string, version = 1): string {
    const baseUrl = this.getBaseUrl(version);
    const mixed = this.getMixedUrl(url, baseUrl);
    return mixed;
  }

  private getMixedUrl(relativeUrl: string, baseUrl: string): string {
    return baseUrl + relativeUrl;
  }

  /**
   * @param relativeUrl
   * @deprecated Do not use this, will be removed in next versions.
   */
  private isMixable(relativeUrl: string): boolean {
    const identifier = 'unknown';

    if (typeof identifier === 'string') {
      return relativeUrl.startsWith(identifier);
    } else {
      return (identifier as RegExp).test(relativeUrl);
    }
  }

  public getBaseUrl(version = 1): string {
    // version = 2;
    return `https://beta.ziraxi.com/v${version}`;

  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      console.error('An error occurred:', error.error);
    } else {
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }

  private separateByDots(targetString: string, version = 1) {
    const splitted = targetString.split('.');
    const methodName = '[separateBtDots]';

    if (splitted.length < 1) {
      throw new Error(
        `${methodName} Error: splitted {length} is less than 1` +
          `${targetString}, ` +
          `${splitted.join(',')}`
      );
    }

    splitted.unshift(`v${version}`);
    return splitted;
  }

  /**
   * Get splitted keys within object.
   * @param splittedKeys Splitted target strings
   * @returns
   */
  private getTarget<T>(splittedKeys: string[], object: object): T {
    let data = undefined;
    let renderedOnce = false;
    // Go deep down to get the result or throw an error

    const methodName = 'Config service';

    for (let target of splittedKeys) {
      if (!data) {
        data = (object as any)[target];
        renderedOnce = true;
      } else {
        data = data[target];
      }

      if (!data && renderedOnce) {
        throw new Error(
          `${methodName} Error: The target you are searching not found` +
            ` target: ${target}, previous data: ${data}`
        );
      }
    }

    return data;
  }
}
